export default {
  agencies: {
    loading: false,
    error: null,
    data: [],
  },
};
